import React from 'react'
import ExcelFile from '../components/ExcelFile'

const Familias = () => {

    return(
        <div>
            <br/> 
            <ExcelFile />
            

        </div>
    )
}
export default Familias